import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { APP_CONFIG } from '../services/app-config.service';
import { getActiveAdGroups } from '../../modules/login/util/constants';

import { UserService } from '../services/user.service';
import { CONTENT } from './util/content';
import { Constants, SsoApplicationType } from '../../shared/constants/constants';
import { Roles } from 'src/app/shared/constants/roles';
import { NgClass } from '@angular/common';


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [NgClass]
})
export class HeaderComponent {

	@Input() isDefaultHeaderMode = false;
	content = CONTENT;
	ROLES = Roles;

	// Returns true if Azure login flow is enabled (from sessionStorage)
	get isAzureLoginEnabled(): boolean {
		return localStorage.getItem('ENABLE_AZURE_LOGIN') === 'true';
	}

	// AD group for Member Payment Research — resolved via getter so APP_CONFIG is guaranteed loaded
	get memberPaymentAdminGroup(): string {
		return getActiveAdGroups().MEMBER_PAYMENT_ADMIN;
	}

	get superAdminGroup(): string {
		return getActiveAdGroups().SUPER_ADMIN;
	}

	constructor(
		public user: UserService,
		private router: Router
	) { }

	hasMemberPaymentAccess(): boolean {
		if (this.isAzureLoginEnabled) {
			return [this.memberPaymentAdminGroup, this.superAdminGroup]
				.some(group => this.user.getAdGroups.includes(group));
		}
		// Non-AD flow: behave as normal (show the menu)
		return true;
	}

	hasBenefitLookupAccess(): boolean {
		if (this.isAzureLoginEnabled) {
			return this.user.getAdGroups.length > 0;
		}
		const userAccessList = [this.user.getUserRole, ...this.user.getUserPrivilegesList];
		return [Roles.SUPER_ADMIN, Roles.ADMIN, Roles.REPRESENTATIVE].some(r => userAccessList.includes(r));
	}

	hasMyProfileAccess(): boolean {
		if (this.isAzureLoginEnabled) {
			return this.user.getAdGroups.length > 0;
		}
		return true;
	}

	goToHome() {
		this.router.navigate(['/home']);
	}

	redirectBenefitLookup(){
		this.router.navigate(['/benefits/benefit-lookup']);
	}

	memberPaymentResearchSso() {
		const url = this.router.serializeUrl(
			this.router.createUrlTree([Constants.SSO_REDIRECTION_FULL_PATH], {
				queryParams: {
					sso: SsoApplicationType.MEMBER_PAYMENT_RESEARCH
				}
			})
		);
		window.open(url, SsoApplicationType.MEMBER_PAYMENT_RESEARCH);
	}

	goToProfile() {
		if (this.isAzureLoginEnabled) {
			this.router.navigate(['/my-profile/details']);
		} else {
			this.router.navigate(['/my-profile']);
		}
	}

	logOff() {
		if (this.isAzureLoginEnabled) {
			this.user.logoutUser();
			this.router.navigate(['/landing']);
		} else {
			this.user.logoutUser();
			this.router.navigate(['/login']);
		}
	}
}
